export default "__VITE_ASSET__05257ffd__"